export default {
  zh: {
    title: '房间奖励',
    current: '当前房间奖杯',
    ratio: '比例',
    get: '提取',
    today: '今天奖励',
    month: '本月奖励',
    lastMonth: '上个月奖励',
    rule: '奖励规则',
    content: '房主可根据房间奖杯数值获得相应的金币',
    text: '房间奖杯数值越高，房间奖励比例越高',
    detail: '每次提高房间奖励比例',
    gold: '房间金币',
    medal: '房间勋章',
    rewards: '奖励比例',
    success: '提取成功',
    tips: '亲爱的用户，我们将于本周日停止房间奖励功能，同时，提高房间支持的奖励。',
    rulesConten: `奖励规则:<br/>
    1.房主可根据房间杯数获得奖励金币，房间杯数越高，房间奖励比例越高。
    2.奖励比例根据房间奖杯等级提升而增加。
    3.最低提现金额为1K。 如果过去30天内房间奖杯数量没有增加，未提取的金币将过期并被清除。
    4.统计时间为用户在座位的时间，无论是否打开麦克风。    
    `,
    setTest:"页面关闭",
  },
  en: {
    title: 'Room reward',
    current: 'Current room reward',
    ratio: 'reward',
    get: 'Get',
    today: "Today",
    setTest:"This event has ended",
    month: 'This Monthly',
    lastMonth: 'Last month',
    rule: 'Reward Rules',
    content: 'The owner can get the reward gold coins according to the room cup',
    text: 'The higher the room cup, the higher the room reward ratio',
    detail: 'Increase the room reward ratio each time',
    gold: 'Room Cup',
    rewards: 'Reward ratio',
    success: 'transaction completed',
    tips: 'Dear users, we will stop the room reward function this Sunday, and at the same time, increase the reward of room support.',
    rulesConten:`Reward Rules:<br/>
    1.The owner can get the reward gold coins according to the room cup.The higher the room cup, the higher the room reward ratio.<br/>
    2.Increase the room reward ratio each time.<br/>
    3.The minimum amount to withdraw is 1K. If the number of room trophies has not increased in the past 30 days, unwithdrawn gold coins will expire and be cleared.<br/>
    4.The statistical time is the time the user is on the mic, regardless of whether the microphone is turned on or not.`,
    roomCup:"Room cup",
    onMicTime:"On mic time",
    medal:"Medal",
    ratioText:"Ratio",
  },
  ar: {
    title: 'مكافأة الغرفة',
    current: 'المكافأة الحالية للغرفة',
    ratio: 'المكافأة',
    setTest:"تم  انتهاء الحدث",
    get: 'إستلام',
    today: 'المكافأة اليومية',
    month: 'المكافأة الشهرية',
    lastMonth: 'مكافأة الشهر الماضي',
    rule: 'قوانين المكافئة',
    content: 'يستطيع صاحب الغرفة أخد المكافئة وفقا لكأس الغرفة',
    text: 'كلما زاد كأس الغرفة ، زادت مكافئة الغرفة',
    detail: 'قم بزيادة نسبة مكافأة الغرفة في كل مرة',
    gold: 'كأس الغرفة',
    rewards: 'نسبة المكافئة',
    success: 'إكتملت المعاملة',
    tips: 'عزيزي مستخدمي ، سنقوم بإيقاف وظيفة مكافأة الغرفة يوم الأحد ، وفي نفس الوقت سنزيد مكافأة دعم الغرفة',
    rulesConten: `قواعد المكافأة: <br/>
    1. يمكن للمالك الحصول على العملات الذهبية للمكافأة وفقا لكأس الغرفة. كلما ارتفع كأس الغرفة، ارتفعت نسبة مكافأة الغرفة.<br/>
    2. قم بزيادة نسبة مكافأة الغرفة في كل مرة.<br/>
    3. الحد الأدنى للسحب هو 1 ألف. إذا لم يزداد عدد جوائز الغرف في الأيام الثلاثين الماضية، فستنتهي صلاحية العملات الذهبية غير المسحوبة وسيتم تطهيرها.<br/>
    4. الوقت الإحصائي هو الوقت الذي يكون فيه المستخدم على الميكروفون، بغض النظر عما إذا كان الميكروفون قيد التشغيل أم لا. 
    `,
    roomCup:"كأس الغرف",
    onMicTime:"وقت المايك",
    medal:"الشارة",
    ratioText:"النسبة",
  },
  jp: {
    title: '部屋の報酬',
    current: '現在の部屋の報酬d',
    ratio: '褒美',
    setTest:"This event has ended",
    get: '得る',
    today: '今日の報酬',
    month: '毎月の報酬',
    lastMonth: '先月の報酬',
    rule: '報酬ルール',
    content: 'オーナーはルームカップに応じてリワードゴールドコインを獲得できます',
    text: 'ルームカップが高いほど、ルーム報酬率は高くなります',
    detail: '毎回部屋の報酬率を上げる',
    gold: 'ルームカップ',
    rewards: '報酬率',
    success: 'トランザクションが完了しました',
    tips: 'ユーザーの皆様へ ルームリワード機能を今週の日曜日に停止し、同時にルームサポートのリワードを増やします。',
    rulesConten: `褒賞ルール:<br/>
    1.オーナーは、ルームカップに応じて報酬金貨を獲得できます。ルームカップが高いほど、ルーム報酬率が高くなります。<br/>
    2.部屋報酬率を毎回上げます。<br/>
    3.出金の最低額は1Kです。過去30日間にルームトロフィーの数が増えていない場合、未出金の金貨は期限切れになり、クリアされます。<br/>
    4.2024年3月1日より施行します。<br/>
    `,
    roomCup:"Room cup",
    onMicTime:"On mic time",
    medal:"Medal",
    ratioText:"Ratio",
  },
  tr: {
    title: 'oda ödülü',
    current: 'Mevcut Oda Kupası',
    ratio: 'ödül',
    get: 'Al',
    setTest:"Etkinlik bitti",
    today: 'Bugünün Ödülü',
    month: 'Aylık Ödül',
    lastMonth: 'Geçen ay Ödül',
    rule: 'Ödül Kuralları',
    content: 'Sahibi, oda kupasına göre ödül altınlarını alabilir.',
    text: 'Oda kupası ne kadar yüksek olursa, oda ödül oranı o kadar yüksek olur',
    detail: 'Her seferinde oda ödül oranını artırın',
    gold: 'oda kupası',
    rewards: 'Ödül oranı',
    success: 'işlem tamamlandı',
    tips: 'Değerli kullanıcılarımız, bu Pazar günü oda ödül fonksiyonunu durduracağız ve aynı zamanda oda desteğinin ödülünü artıracağız.',
    rulesConten: `Ödül Kuralları:<br/>
    1.Oda sahibi, oda kupasına göre bonus alabilir. Oda kupası ne kadar yüksekse, oda ödül oranı da o kadar yüksek olur.<br/>
    2. Her seferinde oda ödül oranını artırmak için, Kupa miktarını yükseltmelisiniz.<br/>
    3. Minimum bonus çekim tutarı 1K'dır. Eğer oda kupası  son 30 gün içinde artmadıysa veya bonuslar alınmaz ise bonusların geçerliliği sona erecek ve silinecektir.<br/>
    4. İstatistiksel zaman, kullanıcının mikrofonda olduğu süredir. Mikrofonun açık olup olmadığına bakılmaksızın hedef süreyi etkileyecektir.`,
    roomCup:"Oda Kupası",
    onMicTime:"Mic Aktiflik",
    medal:"Madalya",
    ratioText:"Ödül Oranı",
  },
  pt:{
    title: 'Recompensa da sala',
    current: 'Recompensa atual da sala',
    ratio: 'recompensa',
    get: 'Obter',
    today: "Hoje",
    setTest: "Este evento foi encerrado",
    month: 'Este mês',
    lastMonth: 'Mês passado',
    rule: 'Regras de recompensa',
    content: 'O proprietário pode obter as moedas de ouro de recompensa de acordo com a taça da sala',
    text: 'Quanto maior a taça da sala, maior a taxa de recompensa da sala',
    detail: 'Aumente a taxa de recompensa da sala a cada vez',
    gold: 'Taça da sala',
    rewards: 'Taxa de recompensa',
    success: 'transação concluída',
    tips: 'Prezados usuários, vamos parar a função de recompensa da sala neste domingo e, ao mesmo tempo, aumentar a recompensa do suporte da sala.',
    rulesConten: `Regras de recompensa:<br/>
    1. O proprietário pode obter as moedas de ouro de recompensa de acordo com a taça da sala. Quanto maior a taça da sala, maior a taxa de recompensa da sala.<br/>
    2. Aumente a taxa de recompensa da sala a cada vez.<br/>
    3. O valor mínimo para saque é 1K. Se o número de troféus da sala não aumentar nos últimos 30 dias, as moedas de ouro não retiradas irão expirar e serão limpas.<br/>
    4. O tempo estatístico é o tempo que o usuário está no microfone, independentemente de o microfone estar ligado ou não.`,
    roomCup: "Taça da sala",
    onMicTime: "Tempo no microfone",
    medal: "Medalha",
    ratioText: "Taxa",

  },
  id:{
    title: 'Hadiah Ruang',
    current: 'Hadiah ruang saat ini',
    ratio: 'hadiah',
    get: 'Dapatkan',
    today: "Hari ini",
    setTest: "Acara ini telah berakhir",
    month: 'Bulan Ini',
    lastMonth: 'Bulan Lalu',
    rule: 'Aturan Hadiah',
    content: 'Pemilik dapat memperoleh koin hadiah sesuai dengan piala ruang',
    text: 'Semakin tinggi piala ruang, semakin tinggi rasio hadiah ruang',
    detail: 'Tingkatkan rasio hadiah ruang setiap kali',
    gold: 'Piala Ruang',
    rewards: 'Rasio hadiah',
    success: 'Transaksi selesai',
    tips: 'Pengguna yang terhormat, kami akan menghentikan fungsi hadiah ruang pada hari Minggu ini, dan pada saat yang sama, meningkatkan hadiah dukungan ruang.',
    rulesConten: `Aturan Hadiah:<br/>
    1. Pemilik dapat memperoleh koin hadiah sesuai dengan piala ruang. Semakin tinggi piala ruang, semakin tinggi rasio hadiah ruang.<br/>
    2. Tingkatkan rasio hadiah ruang setiap kali.<br/>
    3. Jumlah minimum untuk menarik adalah 1K. Jika jumlah trofi ruang tidak meningkat dalam 30 hari terakhir, koin emas yang tidak ditarik akan kedaluwarsa dan dihapus.<br/>
    4. Waktu statistik adalah waktu pengguna berada di mikrofon, terlepas dari apakah mikrofon menyala atau tidak.`,
    roomCup: "Piala Ruang",
    onMicTime: "Waktu di mikrofon",
    medal: "Medali",
    ratioText: "Rasio",

  },
  uz:{
    "title": "Xona mukofoti",
    "current": "Joriy xona mukofoti",
    "ratio": "mukofot",
    "get": "Olish",
    "today": "Bugun",
    "setTest": "Ushbu tadbir tugadi",
    "month": "Ushbu oy",
    "lastMonth": "O'tgan oy",
    "rule": "Mukofot qoidalari",
    "content": "Xona egasi xona kubogi bo'yicha mukofot oltin tangalarini olishlari mumkin",
    "text": "Xona kubogi baland bo'lsa, xona mukofoti nisbati yuqori bo'ladi",
    "detail": "Har safar xona mukofoti nisbati oshiriladi",
    "gold": "Xona kubogi",
    "rewards": "Mukofot nisbati",
    "success": "Transaksiya muvaffaqiyatli yakunlandi",
    "tips": "Aziz foydalanuvchilar, biz shu yakshanba kuni xona mukofoti funksiyasini to'xtatamiz va shu bilan birga xona qo'llab-quvvatlash mukofotini oshiramiz.",
    "rulesConten": "Mukofot qoidalari:<br/>1. Xona egasi xona kubogi bo'yicha mukofot oltin tangalarini olishi mumkin. Xona kubogi baland bo'lsa, xona mukofoti nisbati yuqori bo'ladi.<br/>2. Har safar xona mukofoti nisbati oshiriladi.<br/>3. Naqd pul olish uchun minimal miqdor 1K. Agar oxirgi 30 kun ichida xona kubogi soni oshmagan bo'lsa, olinmagan oltin tangalar muddati o'tadi va tozalanadi.<br/>4. Statistika vaqti foydalanuvchining mikrofonda bo'lish vaqti bo'lib, mikrofon o'chirilgan bo'lsa ham ahamiyatga ega emas.",
    "roomCup": "Xona kubogi",
    "onMicTime": "Mikrofonda bo'lish vaqti",
    "medal": "Medal",
    "ratioText": "Nisbati"
},
    ru:{
    "title": "Награда за комнату",
    "current": "Текущая награда за комнату",
    "ratio": "награда",
    "get": "Получить",
    "today": "Сегодня",
    "setTest": "Это событие завершено",
    "month": "Этот месяц",
    "lastMonth": "Прошлый месяц",
    "rule": "Правила награды",
    "content": "Владелец может получить награду в виде золотых монет в зависимости от кубка комнаты",
    "text": "Чем выше кубок комнаты, тем выше коэффициент награды комнаты",
    "detail": "Каждый раз увеличивается коэффициент награды комнаты",
    "gold": "Кубок комнаты",
    "rewards": "Коэффициент награды",
    "success": "Транзакция завершена",
    "tips": "Дорогие пользователи, в это воскресенье мы остановим функцию награды за комнату и одновременно увеличим награду за поддержку комнаты.",
    "rulesConten": "Правила награды:<br/>1. Владелец может получить золотые монеты в зависимости от кубка комнаты. Чем выше кубок комнаты, тем выше коэффициент награды комнаты.<br/>2. Каждый раз увеличивается коэффициент награды комнаты.<br/>3. Минимальная сумма для снятия составляет 1K. Если количество кубков комнаты не увеличилось за последние 30 дней, невыведенные золотые монеты истекают и очищаются.<br/>4. Время статистики — это время, когда пользователь находится в микрофоне, независимо от того, включен ли микрофон.",
    "roomCup": "Кубок комнаты",
    "onMicTime": "Время на микрофоне",
    "medal": "Медаль",
    "ratioText": "Коэффициент"
},
    fa:{
    "title": "پاداش اتاق",
    "current": "پاداش اتاق جاری",
    "ratio": "پاداش",
    "get": "دریافت",
    "today": "امروز",
    "setTest": "این رویداد تمام شده است",
    "month": "این ماه",
    "lastMonth": "ماه گذشته",
    "rule": "قوانین پاداش",
    "content": "مالک می‌تواند پاداش سکه‌های طلا را بر اساس جام اتاق دریافت کند",
    "text": "هرچه جام اتاق بالاتر باشد، نسبت پاداش اتاق بالاتر است",
    "detail": "هر بار نسبت پاداش اتاق افزایش می‌یابد",
    "gold": "جام اتاق",
    "rewards": "نسبت پاداش",
    "success": "تراکنش تکمیل شد",
    "tips": "کاربران عزیز، ما این یکشنبه عملکرد پاداش اتاق را متوقف خواهیم کرد و در عین حال پاداش پشتیبانی اتاق را افزایش خواهیم داد.",
    "rulesConten": "قوانین پاداش:<br/>1. مالک می‌تواند پاداش سکه‌های طلا را بر اساس جام اتاق دریافت کند. هرچه جام اتاق بالاتر باشد، نسبت پاداش اتاق بالاتر است.<br/>2. هر بار نسبت پاداش اتاق افزایش می‌یابد.<br/>3. حداقل مبلغ برای برداشت 1K است. اگر تعداد جام‌های اتاق در 30 روز گذشته افزایش نیافته باشد، سکه‌های طلا که برداشت نشده‌اند منقضی شده و پاک می‌شوند.<br/>4. زمان آماری، زمانی است که کاربر در میکروفون است، صرف‌نظر از اینکه میکروفون روشن باشد یا نباشد.",
    "roomCup": "جام اتاق",
    "onMicTime": "زمان در میکروفون",
    "medal": "مدال",
    "ratioText": "نسبت"
}



}



// WEBPACK FOOTER //
// src/pages/app/roomreward/lang.js